import { FC, useCallback, useEffect, useState } from 'react';

import { ModalContainer } from '../modal-container';
import { useTariffDataUpload } from '../../hooks/useTariffDataUpload';
import { useLazyMeQuery } from '../../services/users.api';
import { Button } from '../../shared/ui';

export interface ITariffPurchaseWelcomeProps {
  onClose?: () => void;
}
export const TariffPurchaseWelcome: FC<ITariffPurchaseWelcomeProps> = ({ onClose }) => {
  const [reloading, setReloading] = useState(false);
  const [wasReload, setWasReload] = useState(false);
  const [me, { data, error }] = useLazyMeQuery();
  const { isFetching: isReloading } = useTariffDataUpload(reloading, true);

  const handleClose = useCallback(() => {
    setReloading(true);
  }, []);

  useEffect(() => {
    if (wasReload && !isReloading && data) {
      onClose?.();
    }
    if (isReloading) {
      me();
      setWasReload(true);
    }
  }, [isReloading, onClose, wasReload, reloading, me, data]);

  return (
    <ModalContainer
      width="w-full xs:w-auto xs:max-w-[306px]"
      height="h-full xs:max-h-[513px] min-h-[513px]"
      rounded="xs:rounded-popup"
    >
      <div className=" w-full h-full flex flex-col items-center justify-start text-center">
        <p className="text-body-l-strong pt-20">Спасибо за оплату.</p>
        <p className="text-display-m text-primary pt-10 leading-none">Подписка активирована!</p>
        <p className="text-body-l-strong mt-3">Подробнее в разделе Тарифы.</p>
        <div className="text-heading-md flex flex-col mt-10">
          <p>Вдохновляйте </p>
          <p>изменять себя </p>
          <p>не изменяя себе!</p>
        </div>
        <Button size="lg" variant="dark" className="mt-auto w-[60%]" loading={isReloading} onClick={handleClose}>
          Закрыть
        </Button>
      </div>
    </ModalContainer>
  );
};
